const RELEASES = "https://github.com/rayfish/rayfish/releases/latest";
const API = "https://api.github.com/repos/rayfish/rayfish/releases/latest";

let macosDownload;

// GitHub's DMG filename includes the version. Share one lookup per page load.
export function latestMacosDownload() {
  if (!macosDownload) {
    macosDownload = resolveMacosDownload();
  }
  return macosDownload;
}

async function resolveMacosDownload() {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5000);
  try {
    const response = await fetch(API, { signal: controller.signal });
    if (!response.ok) return RELEASES;
    const release = await response.json();
    const asset = Array.isArray(release.assets)
      ? release.assets.find((asset) =>
          /^Rayfish-.+-arm64\.dmg$/.test(asset.name)
        )
      : null;
    const url = asset && asset.browser_download_url;
    return typeof url === "string" &&
      url.startsWith("https://github.com/rayfish/rayfish/releases/download/")
      ? url
      : RELEASES;
  } catch {
    return RELEASES;
  } finally {
    clearTimeout(timeout);
  }
}
